/**
 * Hide the floating WhatsApp button while a better one is already on screen.
 *
 * Measured on the product page at 375x812 (91% of this store's traffic is
 * mobile): the float sits at x 303-359, the Add to cart button at x 150-359 —
 * the float covers 56px of a 209px button, including the word "cart", in the
 * very first view of the page.
 *
 * Moving the float would only push the collision somewhere else. The reason it
 * should not be there at all is the same one that applies with the cart drawer
 * open: directly under Add to cart is a full-width "Enquire on WhatsApp" button
 * that names this product and carries its SKU and price. While that is on
 * screen the float is a smaller, vaguer duplicate of it — so it steps aside,
 * and comes back the moment it scrolls away.
 *
 * The drawer case is handled in CSS (body:has(dialog[open])); intersection has
 * no CSS equivalent, which is the only reason this file exists.
 */
(() => {
  const float = document.querySelector('.wa-float');
  if (!float) return;

  // The dedicated buttons: product enquiry, and the cart's "order these items".
  //
  // .product-form-buttons is in the list because of where the collision
  // actually happens: on a 375x812 phone the Add to cart row sits at the very
  // bottom of the first view and the enquiry button is just below the fold, so
  // watching only the enquiry button left the float showing over Add to cart —
  // the one frame it had to get right.
  const better = document.querySelectorAll(
    '.whatsapp-enquiry, .whatsapp-cart, .product-form-buttons'
  );
  if (!better.length) return;

  if (!('IntersectionObserver' in window)) return;

  const onScreen = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          onScreen.add(entry.target);
        } else {
          onScreen.delete(entry.target);
        }
      }
      float.toggleAttribute('data-redundant', onScreen.size > 0);
    },
    // A sliver counts as visible: the button is 52px tall, so waiting for a
    // larger share of it would leave the float showing while they overlap.
    { threshold: 0 }
  );

  for (const el of better) observer.observe(el);
})();
